import BaseService from '../base-service';
import NetworkUrls from '../network-urls';

class HomeFrontService extends BaseService {
  async fetchHomeSlider(lang = 'FR') {
    const config = {
      url: NetworkUrls.graphql,
      method: 'post',
      data: {
        query: `
        query ($lang: Lang) {
          RoomPicture { many (limit: 5, sortBy: RAND, onlyMain: true) { absolute_path }},
          HomeSliderText { many (limit: 5, sortBy: DEFAULT, lang: $lang) {lines}}
        }`,
        variables: { lang },
      },
    };
    return this._exec(config);
  }

  async fetchHomeRooms(lang = 'FR') {
    const config = {
      url: NetworkUrls.graphql,
      method: 'post',
      data: {
        query: `
        query ($lang: Lang!) {
          Room {
            many (sortBy: RAND, limit: 4) {
              id,
              name,
              area,
              main_picture {
                absolute_path
              },
              room_group {
                text (lang: $lang) { name }
                room_zone {
                  name
                }
              }
              text (lang: $lang) {
                short_desc,
                short_name
              }
            }
          }
        }`,
        variables: { lang },
      },
    };
    return this._exec(config);
  }

  async fetchBusinessSlider(lang = 'FR') {
    const config = {
      url: NetworkUrls.graphql,
      method: 'post',
      data: {
        query: `
          query ($lang: Lang) {
             RoomPicture { many (limit: 3, sortBy: RAND, onlyMain: false) { absolute_path }},
             BusinessSliderText { many (limit: 3, sortBy: RAND, lang: $lang) {href, lines}}
          }
        `,
        variables: { lang },
      },
    };
    return this._exec(config);
  }

  async fetchLastBlogArticles() {
    //deactivated
    return null;
    const config = {
      url: NetworkUrls.graphql,
      method: 'post',
      data: {
        query: `
          {
            BlogArticle {many (limit: 3) {title, picture, description, link}}
          }
        `,
      },
    };
    return this._exec(config);
  }

  async fetchHomeTexts(lang = 'FR') {
    const config = {
      url: NetworkUrls.graphql,
      method: 'post',
      data: {
        query: `query ($lang: Lang) {
          HomeText {many (lang: $lang) {title, subtitle, content, button_text, button_link, picture}}
        }`,
        variables: {
          lang,
        },
      },
    };
    return this._exec(config);
  }

  async searchRoomGroup(data) {
    const config = {
      url: NetworkUrls.graphql,
      method: 'post',
      data: {
        query: `query (
              $startDate: Date!,
              $endDate: Date!,
              $guestCount: Int!,
              $lang: Lang!
          ) {
            RoomGroup {
                many {
                    text (lang: $lang) {
                       name,
                       display_address
                    },
                    rooms (startDate: $startDate, endDate: $endDate, guestCount: $guestCount) {
                        pictures (onlyMain: false, limit: 4, offset: 0) {
                            absolute_path
                        },
                        price_plans (startDate: $startDate, endDate: $endDate) {
                            hostingPrice
                        },
                        provider
                    }
                }
            }
          }`,
        variables: data,
      },
    };
    return this._exec(config);
  }
}

export const homeFrontService = new HomeFrontService();



// WEBPACK FOOTER //
// ./src/network/services/home-front.service.js